
/**
 * @component Copy
 *
 * Format text and bring consistency accross website.
 * This component also works in pair with our copy plugin to
 * display copies from prismic.
 *
 * @public
 */

export default {
  name: 'CopyComponent',
  props: {
    tag: {
      type: String,
      default: 'p',
    },
    type: {
      type: String,
      default: 'body',
    },
    measure: {
      type: String,
      default: '',
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
};
